import type {
  HeaderData,
  Category,
  SubCategory,
  CategoryAd,
  MemberMenu,
} from './header-api.type';
import { produce } from 'immer';
import { inPeriod } from '@trg/utils';

export function selectLogo(data?: HeaderData) {
  const logo = data?.headerLogo?.layoutData?.banner;
  return logo?.filter(inPeriod)[0];
}

const cleanCategoryAds = produce((draft: Category[]) => {
  function cleanDeepAds(subcategories: SubCategory[]) {
    subcategories.forEach((item) => {
      if (!item) return;
      // eslint-disable-next-line prefer-const
      let { categoryAds, subCategories } = item;
      if (categoryAds && !inPeriod(categoryAds)) {
        categoryAds = {} as CategoryAd;
      }

      if (subCategories && subCategories.length > 0) {
        cleanDeepAds(subCategories);
      }
    });
  }

  draft.forEach(({ subCategories }) => {
    if (subCategories && subCategories.length > 0) {
      cleanDeepAds(subCategories);
    }
  });
});

export function selectTotalCategories(data?: HeaderData) {
  return cleanCategoryAds(data?.totalCategories ?? []);
}

export function selectSearchTmp(data?: HeaderData) {
  const searchTemplate = data?.searchTmp?.layoutData?.text;
  return searchTemplate?.filter(inPeriod)[0];
}

export function selectSearchHotKey(data?: HeaderData) {
  const searchHotKeys = data?.searchHotKey?.layoutData?.text ?? [];
  return searchHotKeys.filter(inPeriod);
}

export function selectIsLogin(data?: HeaderData) {
  return data?.isLogin === 'Y';
}

export function selectMemberMenu(data?: HeaderData) {
  const memberMenus = (data?.Login_Menu?.layoutData?.text ?? []).filter(
    inPeriod
  );

  if (data?.isLogin === 'Y') {
    memberMenus.push({
      mainHeading: '登出',
      link: data?.logoutUrl,
      linkTarget: 'N',
    } as MemberMenu);
  }

  return memberMenus;
}

export function selectSmartBanner(data?: HeaderData) {
  const smartBanner = data?.smartBanner?.layoutData?.banner;
  return smartBanner?.filter(inPeriod)[0];
}
